<nav
  class="navbar navbar-expand p-0 hide-scrollbar"
  id="mainMenu"
  attr.aria-label="{{ 'wcag.mainMenu' | translate }}"
>
  <ul
    class="navbar-nav justify-content-lg-end mb-lg-2 flex-lg-wrap w-100"
    *ngIf="member$ | async as member"
  >
    <ng-container *ngIf="member.status !== 3">
      <li
        class="nav-item"
        *ngFor="
          let item of menuItems$ | async;
          let index = index;
          trackBy: trackByMenuItem
        "
        [ngClass]="{ '': rla.isActive }"
      >
        <a
          class="nav-link"
          [routerLink]="item.link"
          [queryParams]="item.queryParams"
          routerLinkActive="active"
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{
            paths: 'exact',
            queryParams: 'ignored',
            fragment: 'ignored',
            matrixParams: 'ignored'
          }"
          (click)="ticketingReset.emit(); handleLinkClick(item, $event)"
          href="javascript:;"
          [attr.data-test-id]="item.dataTestId"
          [attr.aria-current]="rla.isActive ? 'page' : null"
        >
          <span class="nav-text">
            <ng-container>
              {{ item.translateString | translate }}
            </ng-container>
          </span>
        </a>
      </li>
      <li
        class="nav-item"
        *ngFor="let item of additionalMenuItems; trackBy: trackByMenuItem"
        [ngClass]="{ active: rla.isActive }"
      >
        <a
          [routerLink]="item.link"
          [queryParams]="item.queryParams"
          [fragment]="item.fragment"
          class="nav-link"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{
            paths: 'exact',
            queryParams: 'ignored',
            fragment: 'ignored',
            matrixParams: 'ignored'
          }"
          (click)="ticketingReset.emit(); handleLinkClick(item, $event)"
          #rla="routerLinkActive"
          href="javascript:;"
          [attr.data-test-id]="item.dataTestId"
          [attr.aria-current]="rla.isActive ? 'page' : null"
        >
          <span class="nav-text">
            {{ item['title_' + (configurationService.selectedLang$ | async)] }}
          </span>
        </a>
      </li>
    </ng-container>

    <ng-container *ngIf="member.status === 3">
      <li
        class="nav-item"
        *ngFor="
          let item of menuItems$ | async;
          let index = index;
          trackBy: trackByMenuItem
        "
        [ngClass]="{ '': rla.isActive }"
      >
        <a
          class="nav-link"
          [routerLink]="item.link"
          [queryParams]="item.queryParams"
          routerLinkActive="active"
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{
            paths: 'exact',
            queryParams: 'ignored',
            fragment: 'ignored',
            matrixParams: 'ignored'
          }"
          (click)="ticketingReset.emit(); handleLinkClick(item, $event)"
          href="javascript:;"
          [attr.data-test-id]="item.dataTestId"
          [attr.aria-current]="rla.isActive ? 'page' : null"
        >
          <span class="nav-text">
            {{ item.translateString | translate }}
          </span>
        </a>
      </li>
    </ng-container>
  </ul>

  <ul
    class="navbar-nav justify-content-lg-end mb-lg-2 flex-lg-wrap w-100"
    *ngIf="!(member$ | async)"
  >
    <li
      class="nav-item"
      *ngFor="
        let item of menuItems$ | async;
        let index = index;
        trackBy: trackByMenuItem
      "
      [ngClass]="{ '': rla.isActive }"
    >
      <a
        class="nav-link"
        [routerLink]="item.link"
        [queryParams]="item.queryParams"
        routerLinkActive="active"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{
          paths: 'exact',
          queryParams: 'ignored',
          fragment: 'ignored',
          matrixParams: 'ignored'
        }"
        (click)="ticketingReset.emit(); handleLinkClick(item, $event)"
        href="javascript:;"
        [attr.data-test-id]="item.dataTestId"
        [attr.aria-current]="rla.isActive ? 'page' : null"
      >
        <span class="nav-text">
          {{ item.translateString | translate }}
        </span>
      </a>
    </li>
  </ul>
</nav>
